import { useEffect, useState, type CSSProperties } from 'react';
import { attachmentsApi, type UploadedAttachment } from '../lib/api/attachments';

/** Preview ảnh có xác thực Bearer — không dùng URL public cho tệp nội bộ. */
export function AttachmentImagePreview({ attachment, alt, style }: { attachment: UploadedAttachment; alt: string; style?: CSSProperties }) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    let objectUrl: string | null = null;
    attachmentsApi.previewUrl(attachment.id).then((value) => {
      objectUrl = value;
      if (active) setUrl(value);
      else URL.revokeObjectURL(value);
    }).catch(() => { if (active) setUrl(null); });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [attachment.id]);

  if (!url) return <div aria-label="Đang tải ảnh" style={{ display: 'grid', placeItems: 'center', background: '#dbeafe', color: '#2563eb', ...style }}>▧</div>;
  return <img src={url} alt={alt} style={{ display: 'block', width: '100%', objectFit: 'cover', ...style }} />;
}
